export default __webpack_public_path__ + "static/genopets-2cddb5f798561f5eb2085d615b86bdd6.png";